<template>
  <div>
    <wc-section-title title='Irrigation'></wc-section-title>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'irrigation-base',
  data: () => ({
    
  }),
  computed: {
    menu () {
      return [
        {
          title: 'Irrigation Dashboard',
          icon: 'mdi-water',
          route: { name: 'IrrigationDashboard' }
        },
        {
          title: 'Systems Report',
          icon: this.$store.state.icons.dataBox.report.icon,
          route: { name: 'IrrigationReports' }
        },
        {
          title: 'Controllers',
          icon: 'mdi-gamepad-circle',
          route: { name: 'Controllers' }
        },
        {
          title: 'SUBD Tiers',
          icon: this.$store.state.icons.dataBox.subdTier.icon,
          route: { name: 'SUBDTiers' }
        }
      ]
    }
  },
  mounted () {
    this.$store.dispatch('loadMainMenuTitle', 'Irrigation Menu')
    this.$store.dispatch('loadMainMenu', this.menu)
  }
}
</script>